import { ApiService } from "../API/AxiosInstance";

export const deleteDeviceToken = async () => {
  try {
    const deviceId = localStorage.getItem("device_id");
    const fcmToken = localStorage.getItem("fcm_token");
    const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ''

    if (!deviceId || !fcmToken) {
      return;
    }

    const payload = {
      userId: userId,
      token: fcmToken,
      platform: "web"
    };

    await ApiService().post(`notifications/devices/${deviceId}/delete`, payload);

    console.log("Pre logout API triggered ",payload);
  } catch (error) {
    console.error("Pre logout API failed", error);
  }
};